import { useEffect, useState } from "react";
import { Button, Col, Form, Pagination, Row, Table } from "react-bootstrap";
import { useOutletContext } from "react-router-dom";
import httpRequest from "./HttpRequestService";
import SmsR from "./layout/SmsR";

const SmsReceive = () => {
    const [token] = useOutletContext();
    const [data, setData] = useState([]);

    const [filter, setFilter] = useState({
        key: [],
        perpage: 10,
        page: 1,
        pages: 1,
        sort: [{ title: 'createdAt', value: -1 }],
        limiter: [],
        metaFilters: []
    });

    const goPage = (page) => load({ ...filter, page });

    const load = async (filtre = null) => {
        try {
            const response = await httpRequest(`${token}/smsReceive/list`, { filtre: filtre ?? filter }, false);
            if (response.data) {
                setData(response.data.data);
                setFilter(response.data.filter);
            }
        } catch (error) {
            console.error(error.response?.data);
        }
    };

    useEffect(() => { load(); }, []);

    const setLimiterDate = (field, value) => {
        let limiter_tmp = [...filter.limiter];
        const limit = limiter_tmp.find(l => l.title === "createdAt");
        if (limit) {
            limiter_tmp[limiter_tmp.indexOf(limit)][field] = value;
        } else {
            limiter_tmp.push({ title: "createdAt", min: null, max: null, [field]: value });
        }
        setFilter({ ...filter, limiter: limiter_tmp });
    };

    const items = [];
    if (filter.page > 1) items.push(
        <Pagination.Item onClick={() => goPage(filter.page - 1)} key="prev">Précédent</Pagination.Item>
    );
    items.push(
        <Pagination.Item onClick={() => goPage(filter.page)} key={filter.page} active>{filter.page}</Pagination.Item>
    );
    if (filter.page < filter.pages) items.push(
        <Pagination.Item onClick={() => goPage(filter.page + 1)} key="next">Suivant</Pagination.Item>
    );

    return (
        <>
            {/* Filter bar */}
            <div className="filter-bar">
                <Row className="g-2 align-items-end">
                    <Col xs={12} md={3}>
                        <Form.Label>Date début</Form.Label>
                        <Form.Control
                            type="date"
                            size="sm"
                            value={filter.limiter.find(l => l.title === "createdAt")?.min || ''}
                            onChange={(e) => setLimiterDate('min', e.target.value)}
                        />
                    </Col>
                    <Col xs={12} md={3}>
                        <Form.Label>Date fin</Form.Label>
                        <Form.Control
                            type="date"
                            size="sm"
                            value={filter.limiter.find(l => l.title === "createdAt")?.max || ''}
                            onChange={(e) => setLimiterDate('max', e.target.value)}
                        />
                    </Col>
                    <Col xs={12} md={2} className="d-flex gap-2">
                        <Button variant="primary" size="sm" onClick={() => load({ ...filter, page: 1 })} className="flex-fill">
                            🔍 Filtrer
                        </Button>
                        <Button variant="outline-secondary" size="sm" onClick={() => load()} className="flex-fill">
                            ↺ Actualiser
                        </Button>
                    </Col>
                </Row>
            </div>

            {/* Table */}
            <div className="admin-card">
                <div style={{ padding: '12px 16px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '13px', color: '#6c757d' }}>
                        Page <strong>{filter.page}</strong> / {filter.pages}
                    </span>
                    <Pagination size="sm" className="mb-0">{items}</Pagination>
                </div>

                <Table responsive className="table-admin mb-0">
                    <thead>
                        <tr>
                            <th>Passerelle</th>
                            <th>Date</th>
                            <th>Numéro</th>
                            <th>Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="text-center text-muted py-4">
                                    Aucun SMS reçu
                                </td>
                            </tr>
                        ) : (
                            data.map((dt, index) => <SmsR key={index} dt={dt} />)
                        )}
                    </tbody>
                </Table>

                <div style={{ padding: '8px 16px', display: 'flex', justifyContent: 'flex-end' }}>
                    <Pagination size="sm" className="mb-0">{items}</Pagination>
                </div>
            </div>
        </>
    );
};

export default SmsReceive;
